<template>
  <div class="ripple">
      <template v-for="(item, index) in 13">
          <img v-show="Index%13==index" :src="require('../../assets/images/ripple/'+index+'.png')" :key="index" alt="">
      </template>
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){}
}
</script>
<style scoped>
.ripple{
  position: absolute;
  left: .2rem;
  top: .29rem;
  z-index: 10;
  width: 7rem;
  height: 10rem;
}
.ripple img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>